import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";
import { MS_IN_DAY } from "../../components/risk/geoUtils";

interface TimeDataState
{
    minDataTime: number;
    maxDataTime: number;
    currentDay: number;
}

const initialState: TimeDataState = {
    minDataTime: 0,
    maxDataTime: 0,
    currentDay: 0,
};
export interface MinMaxPayload
{
    min: number;
    max: number;
}
export const timelineSlice = createSlice( {
    name: "timeData",
    initialState,
    reducers: {
        setMinMaxDataTime: ( state, action: PayloadAction<MinMaxPayload> ) =>
        {
            state.minDataTime = action.payload.min;
            state.maxDataTime = action.payload.max;
        },
        setCurrentDay: ( state, action: PayloadAction<number> ) =>
        {
            state.currentDay = action.payload;
        },
    },
} );

export const { setMinMaxDataTime, setCurrentDay } = timelineSlice.actions;

// Selectors
export const selectMinDataTime = ( state: RootState ) => state.timeline.minDataTime;
export const selectMaxDataTime = ( state: RootState ) => state.timeline.maxDataTime;
export const selectCurrentDay = ( state: RootState ) => state.timeline.currentDay;

export const useMinDataTime = () => useAppSelector( selectMinDataTime );
export const useMaxDataTime = () => useAppSelector( selectMaxDataTime );
export const useCurrentDay = () => useAppSelector( selectCurrentDay );

// Utility functions
const isMobile = ( state: RootState ) => state.pageWidth.isMobile; // Use the existing selector

export const getMinDisplayTime = ( state: RootState ) => isMobile( state ) ? Math.max( state.timeline.currentDay, state.timeline.minDataTime ) : state.timeline.minDataTime;

export const getMaxDisplayTime = ( state: RootState ) => isMobile( state ) ? Math.min( state.timeline.currentDay + ( MS_IN_DAY - 1 ), state.timeline.maxDataTime ?? 0 ) : state.timeline.maxDataTime; //a day ends at 11:59, not at midnight, so we subtract 1 from MS_IN_DAY

export const useMinDisplayTime = () => useAppSelector( getMinDisplayTime );
export const useMaxDisplayTime = () => useAppSelector( getMaxDisplayTime );

export default timelineSlice.reducer;
